<template>
  <div>


    <m-row class="mt-4">
      <m-col lg="6">
        <memlist-checkbox
          v-model="show_system"
          :text="$t('TEMPLATE.SHOW_SYSTEM')"
        />
        <memlist-checkbox
          v-if="type === 'EMAIL'"
          class="mt-4"
          v-model="show_theme"
          :text="$t('TEMPLATE.SHOW_THEME')"
        />
      </m-col>
      <m-col lg="6">
        <div class="d-flex justify-end">
          <memlist-icon-button
            icon="flaticon2-plus"
            variant="primary"
            class="mt-3"
            :text="$t('TEMPLATE.NEW')"
            @click="createTemplateClicked"
          />
        </div>
      </m-col>
    </m-row>


    <m-row>
      <m-col lg="12">
        
      </m-col>
    </m-row>
    
    <m-row>
      <m-col lg="6" >
        <div class="bottom-alignment">
          <strong>{{ $t('TEMPLATE.NUM_RECORDS') }}:</strong> {{ total_rows }}
        </div>
      </m-col>
      <m-col lg="2">
        
      </m-col>
      <m-col cols="4">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">
          <div class="btn-group" style="margin-top: 6px; margin-right: 8px;">
          <button
            class="icon-btn"
            :class="{ active: viewMode === 'grid' }"
            @click="viewMode = 'grid'"
            aria-label="Rutnät"
          >
            <span class="svg-icon-event-blue">
              <inline-svg src="/assets/svg/grid2.svg"></inline-svg>
            </span>
          </button>

          <button
            class="icon-btn"
            :class="{ active: viewMode === 'list' }"
            @click="viewMode = 'list'"
            aria-label="Lista"
          >
            <span class="svg-icon-event-blue">
              <inline-svg src="/assets/svg/list.svg"></inline-svg>
            </span>
          </button>

        </div>
          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="advance-file-table"
          />

        </div>
      </m-col>
    </m-row>

    <div v-if="viewMode === 'list'">
      
      <memlist-static-table
        id="template-table"
        :fields="headers"
        :items="items"
        :per_page="per_page"
        :current_page="current_page"
      >
        <template #cell(is_email)="row">
          <memlist-checkbox 
            v-model="row.item.is_email"
            disabled
          />
        </template>
        <template #cell(is_sms)="row">
          <memlist-checkbox 
            v-model="row.item.is_sms"
            disabled
          />
        </template>
        <template #cell(is_system)="row">
          <memlist-checkbox 
            v-model="row.item.is_system"
            disabled
          />
        </template>
        <template #cell(actions)="row">
          <div class='justify-content-end d-flex'>
            <memlist-table-button class="mr-3" @click="copyTemplateClicked(row.item)" icon="far fa-copy" :tooltip="$t('TEMPLATE.TOOLTIP_COPY')" />
              
            <memlist-table-button class="mr-3" @click="selectTemplateClicked(row.item.template_id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('TEMPLATE.TOOLTIP_EDIT')" />
            
            <memlist-table-button class="mr-3" @click="deleteTemplateClicked(row.item.template_id)" svg="/assets/svg/trash2.svg" :tooltip="$t('TEMPLATE.TOOLTIP_DELETE')" />
          </div>
        </template>
      </memlist-static-table>
    </div>

    <div v-else-if="viewMode === 'grid'">
      <m-row>
        <m-col
          v-for="tpl in items"
          :key="tpl.template_id"
          lg="3"
          class="d-flex"
        >
          <!-- full-width card that reacts on hover/click -->
          <memlist-card
            class="template-card w-100 mt-4"
            @click="selectTemplateClicked(tpl.template_id)"
          >
            <!-- circular ID badge -->
            <span class="template-badge">{{ tpl.template_id }}</span>

            <!-- centred preview -->
            <img
              v-if="tpl.is_email"
              class="template-img"
              :src="`${image_url}/template-preview/${tpl.template_id}?t=${new Date().getTime()}`"
              :alt="tpl.name"
            />
            <span
              v-else-if="tpl.is_sms"
              class="template-icon"
            >
              <inline-svg src="/assets/svg/sms.svg"></inline-svg>
            </span>

            <!-- title inside the card -->
            <h6 class="template-title text-truncate">
              {{ tpl.name }}
            </h6>
          </memlist-card>
        </m-col>
      </m-row>
    </div>
      
  </div>
  
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import dayjs from 'dayjs';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';


export default {
  name: 'TemplatesTable',
  props: ['items', 'titles', 'currentCompanyId', 'type'],
  emits: ['create_template','copyTemplateClicked', 'selectTemplateClicked', 'deleteTemplateClicked', 'changeSystem'],
  mixins: [ toasts ],
  components: {

  },
  watch: {
    show_theme() {
      this.$emit('refresh', this.show_system, this.show_theme)
    },
    show_system() {
      this.$emit('refresh', this.show_system, this.show_theme);
    },
    items() {

    },
  },
  computed:{

    image_url() {
      const domain = get_domain_url();

      if (domain.indexOf('localhost') >= 0) {
        return `http://localhost:3020`;
      }

      return '';
    },
    total_rows() {
      if (!this.items) {
        return 0;
      }

      return this.items.length;
    },
    ...mapGetters([]),
  },
  mounted() {
    
  },
  methods: {


    createTemplateClicked() {
      this.$emit('createTemplateClicked');
    },
    copyTemplateClicked(template) {
      const data = template;
      this.$emit('copyTemplateClicked', data, this.show_system);
    },
    selectTemplateClicked(template_id) {
      this.$emit('selectTemplateClicked', template_id);
    },
    deleteTemplateClicked(template_id) {
      this.$emit('deleteTemplateClicked', template_id);
    },
    changeSystem(template) {
      this.$emit('changeSystem', template);
    },
    getTitle(title_id) {
      this.titles.forEach(t => {

        if (t.id == title_id) {
          return t.name;
        }
      });

      return "";
    },
  },
  data() {
    return {
      viewMode: 'grid',
      show_theme: false,
      show_system: false,
      current_page: 1,
      per_page: 100,
      options: [
        100, 150, 200
      ],
      headers: [
        {
          key: 'name',
          label: 'Namn',
          sortable: true,
          thClass: 'pl-7 align-middle',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'created_at',
          label: 'Skapat',
          thClass: 'w-165px align-middle',
          tdClass: 'w-165px align-middle',
          formatter: (_, __, item) => {
            return item.created_at ? dayjs(item.created_at).format('YYYY-MM-DD HH:mm') : '-'
          },
          sortable: true
        },
        {
          key: 'is_email',
          label: 'E-post',
          thClass: 'w-80px align-middle',
          tdClass: 'align-middle',
        },
        {
          key: 'is_sms',
          label: 'SMS',
          thClass: 'w-50px align-middle',
          tdClass: 'align-middle',
        },
        {
          key: 'is_system',
          label: 'System',
          thClass: 'w-50px align-middle',
          tdClass: 'pl-8 align-middle'
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'text-right pr-12 align-middle',
        },
      ],

    };
  }
};
</script>
<style lang="css" scoped>
.btn-group {
  display: flex;
  gap: .5rem; /* space between buttons */
  margin-left: auto; /* push group to the far right */
}
.icon-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background .15s, border-color .15s;
}
.icon-btn svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}
.icon-btn:hover,
.icon-btn:focus {
  background: #f1f3f5;
}

/* active (toggled) state */
.icon-btn.active {
  background: #3699FF;
  border-color: #3699FF;
  color: #fff;
}

/* default (inactive) colour */
.icon-btn:not(.active) .svg-icon-event-blue,
.icon-btn:not(.active) .svg-icon-event-blue * {
  color: #3699FF;
  fill: currentColor;        /* SVG paths follow the text colour */
}

/* active → invert to white */
.icon-btn.active .svg-icon-event-blue,
.icon-btn.active .svg-icon-event-blue * {
  color: #fff;
  fill: currentColor;
}
.template-card {
  position: relative;
  padding: 0.75rem;
  transition: box-shadow 0.15s, transform 0.15s;
  cursor: pointer;
}

.template-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* -------- circular ID badge -------- */
.template-badge {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: white;
  color: #3699ff;
  border: 1px solid #3699ff;
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* -------- centred image -------- */
.template-img {
  display: block;
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: top;
}

.template-icon {
  display: block;        /* makes margin auto work */
  max-width: 100px;      /* same visual size as before */
  max-height: 200px;
  margin: 0 auto;        /* centres horizontally */
  text-align: center;    /* centres inline-svg’s internal paths */
}


/* -------- title -------- */
.template-title {
  margin-top: 0.75rem;
  margin-bottom: 0;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* remove old helper */
.image-preview { display: none; }

</style>